import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/biblioteca/components/resource.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/biblioteca/components/search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ui/tables/Pagination.tsx");
